<div class="card traveller-card mb-1">
  <div class="imageOverlay">
    <img
      [src]="
        data?.photos?.[0] ||
        'https://img.veenaworld.com//group-tours/world/europe/eusc/eusc-bnn-1.jpg?imwidth=1300&impolicy=nowatermark'
      "
      [alt]="data?.storyTitle || ''"
      class="card-img-top"
    />
    <div class="overlay"></div>
    <div class="captionOverlay">
      <div class="mb-3">
        <h2 class="fs-14 mb-0 story-title">{{ data?.storyTitle }}</h2>
        @if (data?.rating) {
        <div class="d-flex justify-content-center mt-2 mb-2">
          <div
            *ngFor="let star of getStarsArray(data?.rating || 0)"
            class="star-rating-img"
            [ngClass]="{
              'filled-star': star.filled,
              'blank-star': !star.filled
            }"
          ></div>
        </div>
        }
      </div>

      <div class="d-flex justify-content-center gap-2 action-buttons">
        <a
          [routerLink]="['/', 'tour-packages', data?.destinationInfo?.slug]"
          [state]="{
            destinationId: data?.destinationInfo?._id,
            sortBy: 'price',
            sortOrder: 'asc',
            page: 1,
            limit: 15,
          }"
        >
          <app-button
            type="secondary"
            class="fs-10 slim"
            [title]="data?.destinationInfo?.name"
            >View {{ truncatedDestinationName }} Packages</app-button
          >
        </a>
        @if(showReadMore){
        <app-button
          type="secondary"
          class="fs-10 slim"
          (click)="openLeadModal(data)"
          >Read More</app-button
        >
        }
        <!-- <app-button type="secondary" class="fs-12 slim" (click)="openLeadModal()">Get Quote</app-button> -->
      </div>
    </div>
  </div>
</div>
